export default __webpack_public_path__ + "static/media/sm4.36ac62b5.png";